/**
 * YouTube erst nach Klick laden (Datenschutz, keine externen Dienste vorab).
 * <div class="c-video" data-video-id="…"> … <a class="c-video__play" href="youtube.com/watch…"> …
 * Ohne JS ist der Play-Knopf ein normaler Link zu YouTube, es wird kein iframe eingebettet.
 */
export function initVideo() {
  document.querySelectorAll('.c-video[data-video-id]').forEach((box) => {
    box.querySelector('.c-video__play')?.addEventListener('click', (e) => {
      e.preventDefault();
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(box.dataset.videoId)}?autoplay=1`;
      iframe.title = box.dataset.title || 'Video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      box.replaceChildren(iframe);
      iframe.focus();
    });
  });
}
